// extracted by mini-css-extract-plugin
module.exports = {"icon":"ExpandCollapseIcon__icon___3QysL","gray":"ExpandCollapseIcon__gray___3rgKX","tpb":"ExpandCollapseIcon__tpb___1z_1v"};